export function platformRequestConfig(companyId) {
  if (!companyId) return { withCredentials: true };
  return {
    withCredentials: true,
    params: { company_id: companyId },
  };
}

/**
 * Client-side company filter for unscoped platform lists.
 * Do NOT use when the request already sent company_id — that double-filter
 * empties lists if rows omit company_id (platform scope bug class).
 * Rows missing the key are kept so a backend meta gap cannot wipe the list.
 */
export function filterByCompany(items, companyId, key = 'company_id') {
  if (!companyId) return items;
  return items.filter((item) => {
    if (item[key] == null) return true;
    return String(item[key]) === String(companyId);
  });
}
